export default __webpack_public_path__ + "static/media/logo.76b1e54a.jpeg";